module.exports = __webpack_public_path__ + "static/media/font-size.419cef2f.svg";